"use client";

import RouteError from "@/components/RouteError";

export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <RouteError
      {...props}
      boundary="kundli_matching_route"
      message="We could not load kundali milan. Please try again."
    />
  );
}
